import environment from "environment";

const API = {
  VERIFY_OTP: () => {
    return `${environment.api}/endusers/verifyOTP`;
  },
  LOGIN: () => {
    return `${environment.api}/endusers/requestOTP`;
  },
  GET_INFERENCE: (branchId) => {
    return `${environment.api}/branches/${branchId}/models/inference`;
  },
  GET_MINIFIED_PRODUCTS: (branchId) => {
    return `${environment.api}/branches/${branchId}/products/minified`;
  },
  CREATE_FEEDBACK: () => {
    return `${environment.api}/feedbacks`;
  },
  GET_PROFILE: (userId) => {
    return `${environment.api}/endusers/${userId}`;
  },
  UPDATE_PROFILE: (userId) => {
    return `${environment.api}/endusers/${userId}`;
  },
  GET_ALL_COUPONS: () => {
    return `${environment.api}/eu/coupons`;
  },
  REDEEM_COUPON: () => {
    return `${environment.api}/eu/redeem`;
  },
  GET_COUPON: (couId) => {
    return `${environment.api}/eu/coupons/${couId}`;
  },
  CREATE_ASSET: () => {
    return `${environment.api}/eu/assets/getUploadURL`;
  },
  UPLOAD_ASSET: (endPoint) => {
    return `${endPoint}`;
  },
};

export { API };
